import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AbstractRestService } from '../../../../core/services/AbstractRestService';
import { IPriorityShape, ISeatsPlan, ISectorCopyPayload, ISectorEditPayload, ISectorPayload, IShape } from '../../interfaces';
import { CreatorStateService } from '../app-services';

@Injectable({
  providedIn: 'root'
})
export class SectorsApiService extends AbstractRestService<ISeatsPlan> {

  protected get basePath(): string {
    return `/auditoriums/sectors`;
  };

  public copySector(sectorId: number, payload: ISectorCopyPayload): Observable<ISeatsPlan> {
    return this.apiService.post(`${this.basePath}/${sectorId}`, payload);
  }

  public updateSector(sectorId: number, payload: ISectorPayload): Observable<ISeatsPlan> {
    return this.apiService.put(`${this.basePath}/${sectorId}`, payload);
  }

  public deleteSector(sectorId: number): Observable<ISeatsPlan> {
    return this.apiService.delete(`${this.basePath}/${sectorId}`);
  }

  public getOneSector(sectorId: number, sectorConfigurationId?: number, setInitState: boolean = true): Observable<ISeatsPlan> {
    const params = sectorConfigurationId ? {sectorConfigurationId: sectorConfigurationId.toString()} : {};

    return this.apiService.get(`${this.basePath}/${sectorId}`, params).pipe(
      tap((seatsPlan) => {
        CreatorStateService.seatsPlan = seatsPlan;
        if (setInitState) {
          CreatorStateService.initSeatsPlanState = cloneDeep(seatsPlan);
        }
      })
    );
  }

  public getSectorShapes(sectorId: number): Observable<IShape[]> {
    return this.apiService.get(`${this.basePath}/${sectorId}/shapes`).pipe(
      tap(shapes => CreatorStateService.sectorsShapes = shapes),
    );
  }

  public getSectorPriorityShape(sectorId: number): Observable<IPriorityShape> {
    return this.apiService.get(`${this.basePath}/${sectorId}/weight`).pipe(
      tap(shape => {
        CreatorStateService.priorityShape = shape;
        CreatorStateService.initPriorityShape = shape;
      }),
    );
  }

  public saveSector(sectorId: number, payload: ISectorEditPayload): Observable<void> {
    return this.apiService.put(`${this.basePath}/${sectorId}/save`, payload);
  }

  public saveName(sectorId: number, payload: { name: string }): Observable<void> {
    return this.apiService.put(`${this.basePath}/${sectorId}/name`, payload);
  }
}
